<template>
  <div
    class="bg-logo-color py-20 relative overflow-hidden"
    ref="counterSection"
  >
    <!-- Decorative Shapes -->
    <div class="absolute inset-0 pointer-events-none">
      <!-- Large Circle Top Right -->
      <div
        class="absolute -top-20 -right-20 w-80 h-80 bg-white/5 rounded-full"
      ></div>
      <!-- Medium Circle Bottom Left -->
      <div
        class="absolute -bottom-16 -left-16 w-64 h-64 bg-white/5 rounded-full"
      ></div>
      <!-- Small Circle Top Left -->
      <div
        class="absolute top-10 left-1/4 w-20 h-20 bg-white/10 rounded-full hidden lg:block"
      ></div>
      <!-- Ring Shape Right -->
      <div
        class="absolute top-1/2 -translate-y-1/2 -right-10 w-40 h-40 border-4 border-white/10 rounded-full hidden lg:block"
      ></div>
      <!-- Diagonal Line -->
      <div
        class="absolute top-0 left-1/3 w-px h-full bg-gradient-to-b from-transparent via-white/10 to-transparent hidden lg:block"
      ></div>
      <!-- Dots Pattern -->
      <div
        class="absolute bottom-20 right-1/4 hidden lg:grid grid-cols-3 gap-3"
      >
        <div class="w-2 h-2 bg-white/20 rounded-full"></div>
        <div class="w-2 h-2 bg-white/20 rounded-full"></div>
        <div class="w-2 h-2 bg-white/20 rounded-full"></div>
        <div class="w-2 h-2 bg-white/20 rounded-full"></div>
        <div class="w-2 h-2 bg-white/20 rounded-full"></div>
        <div class="w-2 h-2 bg-white/20 rounded-full"></div>
      </div>
    </div>

    <div class="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <!-- Header -->
      <div class="text-center mb-16" data-aos="fade-up">
        <span
          class="text-white/70 font-semibold text-sm uppercase tracking-wider"
        >
          Our Impact
        </span>
        <h2 class="text-3xl md:text-4xl lg:text-5xl font-bold text-white mt-3">
          Numbers That Matter
        </h2>
      </div>

      <!-- Stats Grid -->
      <div class="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
        <!-- Stat 1 -->
        <div
          class="text-center p-6 rounded-2xl bg-white/10 backdrop-blur-sm"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <div class="text-5xl lg:text-6xl font-bold text-white mb-3">
            {{ counters.revenue }}+
          </div>
          <div class="text-white font-semibold text-lg">Youth Trained</div>
          <div class="text-white/60 text-sm mt-1">Equipped with skills</div>
        </div>

        <!-- Stat 2 -->
        <div
          class="text-center p-6 rounded-2xl bg-white/10 backdrop-blur-sm"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <div class="text-5xl lg:text-6xl font-bold text-white mb-3">
            {{ counters.markets }}+
          </div>
          <div class="text-white font-semibold text-lg">Schools</div>
          <div class="text-white/60 text-sm mt-1">Reached & supported</div>
        </div>

        <!-- Stat 3 -->
        <div
          class="text-center p-6 rounded-2xl bg-white/10 backdrop-blur-sm"
          data-aos="fade-up"
          data-aos-delay="300"
        >
          <div class="text-5xl lg:text-6xl font-bold text-white mb-3">
            {{ counters.clients }}+
          </div>
          <div class="text-white font-semibold text-lg">Mentors</div>
          <div class="text-white/60 text-sm mt-1">Professionals engaged</div>
        </div>

        <!-- Stat 4 -->
        <div
          class="text-center p-6 rounded-2xl bg-white/10 backdrop-blur-sm"
          data-aos="fade-up"
          data-aos-delay="400"
        >
          <div class="text-5xl lg:text-6xl font-bold text-white mb-3">
            {{ counters.efficiency }}%
          </div>
          <div class="text-white font-semibold text-lg">Commitment</div>
          <div class="text-white/60 text-sm mt-1">To youth development</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BusinessGrowthStatistics",
  data() {
    return {
      counters: {
        revenue: 0,
        markets: 0,
        clients: 0,
        efficiency: 0,
      },
      targets: {
        revenue: 500,
        markets: 50,
        clients: 100,
        efficiency: 100,
      },
      hasAnimated: false,
    };
  },
  mounted() {
    this.setupIntersectionObserver();
  },
  methods: {
    setupIntersectionObserver() {
      const options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.3,
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.hasAnimated) {
            this.startCounting();
            this.hasAnimated = true;
          }
        });
      }, options);

      observer.observe(this.$refs.counterSection);
    },
    startCounting() {
      const duration = 2000;
      const steps = 50;
      const interval = duration / steps;

      const animate = () => {
        Object.keys(this.targets).forEach((key) => {
          const target = this.targets[key];
          const increment = target / steps;
          if (this.counters[key] < target) {
            this.counters[key] = Math.min(
              Math.round(this.counters[key] + increment),
              target
            );
          }
        });

        if (
          Object.keys(this.counters).some(
            (key) => this.counters[key] < this.targets[key]
          )
        ) {
          setTimeout(animate, interval);
        }
      };

      animate();
    },
  },
};
</script>

<style scoped></style>
